export default __webpack_public_path__ + "static/media/banner1.a4f34055.webp";